import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { utilBuildings } from "../../utils/utilBuildings";
import { BF2CreateAsset, BF2PositionSurroundingCorner } from "../BF2BuildingGraphicsUtils";
export var GetFenceCornerPillarIso = function (data, orientation, baseSetup) {
    var level = utilBuildings.getVisualLevel(data);
    var config = artConfigBuildings["fenceCornerPillar_" + orientation + "_" + level];
    var sprite = BF2CreateAsset(config.assets[0], false);
    sprite.name = "Fence Corner Pillar [" + orientation + "]";
    BF2PositionSurroundingCorner(sprite, orientation, baseSetup);
    return sprite;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/fence/GetFenceCornerPillarIso.ts
// module id = 2215
// module chunks = 3